import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRefundBanks} from '../../services/getRefundBanks';

export function useGetRefundBanksQuery() {
	return useQuery({
		queryKey: [QUERY_KEYS.REFUND_BANKS],
		queryFn: async ({signal}) => getRefundBanks({signal, page: 1, limit: 1000}),
		retry: 2,
		enabled: false,
	});
}
